<template>
	<v-container>
		<v-alert type="error" v-show="showAlertIncrementIds">
			{{ txt.alert.incrementIds }}
		</v-alert>
		<v-alert type="error" v-show="showAlertMandators">
			{{ txt.alert.mandators }}
		</v-alert>

		<form>
			<v-row>
				<v-col cols="12" md="12">
					<v-autocomplete
						v-model="formState.selectedMandators"
						:items="formItems.mandator"
						hide-selected
						label="Mandator"
						persistent-hint
						chips
						return-object
					></v-autocomplete>
				</v-col>
				<v-col cols="12" md="12">
					<v-text-field
						v-model="formState.incrementIds"
						label="Increment IDs (Comma separated, no spaces, example: 100000001,10000002)"
						persistent-hint
						return-object
					/>
				</v-col>
			</v-row>

			<v-btn
				:disabled="loading"
				class="searchButton ml-5"
				@click="previewOrders"
				>{{ txt.button.previewOrders }}
			</v-btn>

			<v-btn
				:disabled="loading"
				class="searchButton ml-5"
				color="primary"
				@click="loadOrders"
				>{{ txt.button.loadOrders }}
			</v-btn>
		</form>
	</v-container>
</template>

<script>
import axios from 'axios'

export default {
	name: 'OrderImportFilter',
	props: {
		loading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			txt: {
				button: {
					previewOrders: 'Preview Orders',
					loadOrders: 'Load Orders',
				},
				alert: {
					incrementIds: 'Please enter at least one increment ID',
					mandators: 'Please select one mandator',
				},
			},
			formState: {
				selectedMandators: [],
				incrementIds: '',
			},
			formItems: {
				mandator: [],
			},
			showAlertIncrementIds: false,
			showAlertMandators: false,
		}
	},
	methods: {
		async getMandators() {
			try {
				// eslint-disable-next-line no-undef
				const res = await axios.get(`${config.baseAPIurl}/order-import/mandators`)
				this.$data.formItems.mandator = res.data
			} catch (err) {
				console.log(err)
			}
		},

		validate() {
			if (this.formState.incrementIds.length === 0) {
				this.showAlertIncrementIds = true
			} else this.showAlertIncrementIds = false

			if (!this.formState.selectedMandators || this.formState.selectedMandators.length === 0) {
				this.showAlertMandators = true
			} else this.showAlertMandators = false
		},
		previewOrders() {
			this.validate()
			if (!this.showAlertMandators && !this.showAlertIncrementIds) this.$emit('previewOrders', this.formState)
		},
		loadOrders() {
			this.validate()
			if (!this.showAlertMandators && !this.showAlertIncrementIds) this.$emit('loadOrders', this.formState)
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.getMandators()
		})
	},
}
</script>

<style>

</style>
